// frontend/src/components/dashboard/pos/common/PaymentMethodButton.jsx
import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { commonStyles } from '../styles/posStyles';

const PaymentMethodButton = ({
  icon,
  label,
  onClick,
  disabled = false,
  selected = false,
  deviceInfo,
  isTablet,
  ...props
}) => {
  const IconComponent = icon;
  
  // Get device-aware styling
  const deviceType = deviceInfo?.type || 'desktop';
  const screenSize = deviceInfo?.screenSize || 'large';
  const buttonStyles = commonStyles.paymentMethodButton(selected, deviceType, screenSize);
  
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      fullWidth
      className="payment-method-button"
      sx={{
        ...buttonStyles,
        // Override with device-specific styling
        aspectRatio: '1',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'none',
        // Enhanced responsive minHeight
        minHeight: {
          xs: '70px',      // Phone
          sm: isTablet ? '50px' : '70px',  // Small tablet vs other small screens
          md: isTablet ? '55px' : '70px',  // Medium tablet vs other medium screens
          lg: isTablet ? '60px' : '75px',  // Large tablet vs other large screens
          xl: '80px'       // Desktop
        },
        // Enhanced responsive font size
        '& .MuiTypography-root': {
          fontSize: {
            xs: '0.65rem',    // Phone
            sm: isTablet ? '0.55rem' : '0.65rem',   // Small tablet vs other screens
            md: isTablet ? '0.65rem' : '0.7rem',    // Medium tablet vs other screens
            lg: isTablet ? '0.7rem' : '0.75rem',    // Large tablet vs other screens
            xl: '0.8rem'      // Desktop
          },
          fontWeight: 500,
          textAlign: 'center',
          lineHeight: 1.2,
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }}
      {...props}
    >
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        mb: isTablet ? 0.25 : 0.5,
        minHeight: isTablet ? '20px' : '24px'
      }}>
        <IconComponent fontSize={isTablet ? 'small' : 'medium'} />
      </Box>
      <Typography 
        variant="body2" 
        sx={{ 
          fontSize: 'inherit', // Use the fontSize from the button's sx prop
          fontWeight: 500,
          textAlign: 'center',
          lineHeight: 1.2,
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};

export default PaymentMethodButton;